import { useQuery } from "@tanstack/react-query";
import { getStats } from "@/api/admin.api";
import { StatCard } from "@/components/stat-card";
import { Users, Store, UtensilsCrossed, Package, Eye, QrCode } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function DashboardPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "stats"],
    queryFn: getStats,
  });

  if (isLoading) {
    return (
      <div>
        <h1 className="mb-6 text-2xl font-bold">Dashboard</h1>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-24 animate-pulse rounded-xl bg-muted" />
          ))}
        </div>
      </div>
    );
  }

  const stats = [
    { title: "Kullanicilar", value: data?.users.total ?? 0, icon: Users },
    { title: "Isletmeler", value: data?.venues.total ?? 0, icon: Store },
    { title: "Menuler", value: data?.menus.total ?? 0, icon: UtensilsCrossed },
    { title: "Urunler", value: data?.items.total ?? 0, icon: Package },
    { title: "Goruntulenme", value: data?.views.total ?? 0, icon: Eye },
    { title: "QR Kodlar", value: data?.qrCodes.total ?? 0, icon: QrCode },
  ];

  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold">Dashboard</h1>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <StatCard key={s.title} {...s} />
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Kullanici Istatistikleri</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Bugun</span>
              <span className="font-medium">{data?.users.today ?? 0}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Bu Hafta</span>
              <span className="font-medium">{data?.users.thisWeek ?? 0}</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Plan Dagilimi</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            <div className="flex justify-between text-sm">
              <Badge variant="secondary">FREE</Badge>
              <span className="font-medium">{data?.venues.free ?? 0}</span>
            </div>
            <div className="flex justify-between text-sm">
              <Badge className="bg-blue-100 text-blue-700">PRO</Badge>
              <span className="font-medium">{data?.venues.pro ?? 0}</span>
            </div>
            <div className="flex justify-between text-sm">
              <Badge className="bg-purple-100 text-purple-700">BUSINESS</Badge>
              <span className="font-medium">{data?.venues.business ?? 0}</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-base">Goruntulenme</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Bugun</span>
              <span className="font-medium">{data?.views.today ?? 0}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Toplam</span>
              <span className="font-medium">{data?.views.total ?? 0}</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
